import script from "./MachineInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MachineInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MachineInfo.vue?vue&type=style&index=0&id=3f8fba0c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8fba0c"]])

export default __exports__